import { notFound } from '@tanstack/react-router';

export function parseRegisterRouteId(value: string): bigint {
    if (!/^\d+$/.test(value)) {
        throw notFound();
    }

    return BigInt(value);
}
